import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ClearOutlinedSvg from "@ant-design/icons-svg/es/asn/ClearOutlined";
import AntdIcon from "../components/AntdIcon";
var ClearOutlined = function ClearOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ClearOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ClearOutlined.displayName = 'ClearOutlined';
}
export default /*#__PURE__*/React.forwardRef(ClearOutlined);